// src/api/tenantService.js ver 03
import { callCloudFunction } from './apiClient';

export const getTenantProfile = async (tenantDocId, token) => {
    // Use path parameter for tenantDocId
    return callCloudFunction('getTenantProfile', 'GET', null, null, token, null, { pathParams: { tenantDocId } });
};

export const addTenantProfile = async (tenantData, token) => {
    return callCloudFunction('addTenantProfile', 'POST', tenantData, null, token);
};

export const updateTenantProfile = async (tenantDocId, tenantData, token) => {
    // Use path parameter for tenantDocId
    return callCloudFunction('updateTenantProfile', 'PUT', tenantData, null, token, null, { pathParams: { tenantDocId } });
};